import { render, staticRenderFns } from "./home_footer.vue?vue&type=template&id=9d4cf506&scoped=true&"
import script from "./home_footer.vue?vue&type=script&lang=js&"
export * from "./home_footer.vue?vue&type=script&lang=js&"
import style0 from "./home_footer.vue?vue&type=style&index=0&id=9d4cf506&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4cf506",
  null
  
)

export default component.exports